(function () {
  var BADGE_ATTR = 'data-discount-badge';
  var BADGE_CLASS = 'bg-orange text-white border border-orange/10 py-2 px-[10px] rounded-[4px] block uppercase font-semibold text-xs';

  function parsePrice(text) {
    if (!text) return null;
    var cleaned = text.replace(/[^0-9,.-]/g, '').replace(',', '.');
    var value = parseFloat(cleaned);
    return isNaN(value) ? null : value;
  }

  function roundToNearest5(value) {
    return Math.round(value / 5) * 5;
  }

  function updateCard(card) {
    var badgeZone = card.querySelector('[data-ref="badges"]');
    if (!badgeZone) return;

    var comparePriceEl = card.querySelector('.price-item--regular.\\!text-orange');
    var salePriceEl = card.querySelector('.price-item--sale');
    var existingBadge = badgeZone.querySelector('[' + BADGE_ATTR + ']');

    var comparePrice = comparePriceEl ? parsePrice(comparePriceEl.textContent) : null;
    var salePrice = salePriceEl ? parsePrice(salePriceEl.textContent) : null;

    if (!comparePrice || !salePrice || comparePrice <= salePrice) {
      if (existingBadge) existingBadge.remove();
      return;
    }

    var rawPercentage = ((comparePrice - salePrice) / comparePrice) * 100;
    var percentage = roundToNearest5(rawPercentage);

    if (percentage <= 0) {
      if (existingBadge) existingBadge.remove();
      return;
    }

    var label = '-' + percentage + '%';

    if (existingBadge) {
      if (existingBadge.textContent !== label) existingBadge.textContent = label;
      return;
    }

    var badge = document.createElement('span');
    badge.setAttribute(BADGE_ATTR, '');
    badge.className = BADGE_CLASS;
    badge.textContent = label;
    badgeZone.insertBefore(badge, badgeZone.firstChild);
  }

  function scanAll() {
    document.querySelectorAll('[data-ref="badges"]').forEach(function (badgeZone) {
      var card = badgeZone.closest('article') || badgeZone.parentElement;
      if (card) updateCard(card);
    });
  }

  var scheduled = false;
  function scheduleScan() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      scanAll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanAll);
  } else {
    scanAll();
  }

  var observer = new MutationObserver(scheduleScan);
  observer.observe(document.body, { childList: true, subtree: true });
})();
